'use strict';

import Area from '../../common/area';

function LandPlot (object, dictionary) {
  /** @var Area|null */
  this.totalArea = object.get('squareLand') ? new Area('зем.уч.', object.get('squareLand'), Area.MEASURE_AR) : null;

  /** Категория использования */
  this.usage = dictionary.getUsageCategory(object.get('usageCategoryId')) || null;
}

const proto = LandPlot.prototype;

proto.getTotalArea = function () {
  return this.totalArea;
};

proto.getUsageCategory = function () {
  return this.usage;
};

export default LandPlot;



// WEBPACK FOOTER //
// ./src/classes/announcement/property/landPlot.js